@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.body-layout {
  display: flex;
  flex: 1;
  height: 100%;
  overflow: hidden;

  .left {
    flex: 1;
    background-color: @scan-page--layout-details-left--background-color;
    display: flex;
    flex-direction: column;
  }

  .right {
    display: flex;
    overflow: auto;
    background-color: @scan-page--layout-details-right--background-color;
  }
}
